export const ValidateSupportTickets = ({ ticket }) => {
  if (!ticket.subject) {
    return {
      error: "Subject cannot be empty",
      field: "Subject",
    };
  }
  if (ticket.subject.length > 255) {
    return {
      error: "Subject cannot exceed 255 words",
      field: "Subject",
    };
  }
  if (!ticket.query) {
    return {
      error: "Query cannot be empty",
      field: "query",
    };
  }
  if (ticket.contactNumber && ticket.contactNumber.length !== 10) {
    return { error: "Please enter a valid number", field: "Contact Number" };
  }
  if (!ticket.contactName) {
    return {
      error: "Please enter a contact name",
      field: "Contact name",
    };
  }
  // if (!ticket.attachment) {
  //   return {
  //     error:
  //       "You need to provide the screenshot to help us investigate the issue.",
  //   };
  // }
};
